import clsx from 'clsx';
import map from 'lodash/map';
import React from 'react';
import { ParamTypeMultiple } from './LotParam.type';

interface Props {
    type: ParamTypeMultiple;
    actions?: React.ReactNode;
    children: (child: any, index: number) => React.ReactNode;
    classNames?: {
        block?: string;
        list?: string;
        item?: string;
    };
    className?: string;
}

export const ParamMultipleTypes: React.FC<Props> = ({
    type,
    children,
    actions,
    classNames,
    className,
}) => {
    const hasChildren = Boolean(type.children?.length);

    return (
        <div className={clsx(classNames?.block, className)}>
            {hasChildren && (
                <div className={clsx(classNames?.list)}>
                    {map(type.children, (child, index) => (
                        <div key={index} className={clsx(classNames?.item)}>
                            {children(child, index)}
                        </div>
                    ))}
                </div>
            )}
            {actions}
        </div>
    );
};
